import { Component, OnInit } from "@angular/core";
import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import {
  User,
  InviteListConfig,
  NotificationListConfig,
} from "../shared/models";

import { UserService, MenuService } from "../shared/services";
import { Router } from "@angular/router";

@Component({
  selector: "layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
  animations: [
    trigger("notificationBottom", [
      state(
        "an-off, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "an-animate",
        style({
          overflow: "hidden",
          height: AUTO_STYLE,
        })
      ),
      transition("an-off <=> an-animate", [animate("400ms ease-in-out")]),
    ]),
    trigger("mobileHeaderNavRight", [
      state(
        "nav-off, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "nav-on",
        style({
          height: AUTO_STYLE,
        })
      ),
      transition("nav-off <=> nav-on", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class LayoutComponent implements OnInit {
  private defaultUserImg: string =
    "../../../../../assets/images/uMuzi/african-mask.png";
  public loading: boolean = false;
  public currentUser: User;
  public menuItems: any;
  private currentUserSubscription: any;
  public inviteConfig: InviteListConfig = new InviteListConfig();
  public notificationConfig: NotificationListConfig =
    new NotificationListConfig();
  public firstPageInviteCount: number = 0;
  public firstPageNotificationCount: number = 0;

  // template variables
  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public liveInvite: string;
  public liveInviteClass: string;

  public profileInvite: string;
  public profileInviteClass: string;

  public navRight: string;
  public windowWidth: number;

  public toggleOn: boolean;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;

  public configOpenRightBar: string;
  public displayBoxLayout: string;
  public isVerticalLayoutChecked: boolean;
  public isSidebarChecked: boolean;
  public isHeaderChecked: boolean;
  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;

  constructor(
    private userService: UserService,
    private router: Router,
    public menuService: MenuService
  ) {
    this.navType = "st1";
    this.themeLayout = "horizontal"; // vertical
    this.verticalPlacement = "left";
    this.verticalLayout = "wide";
    this.pcodedDeviceType = "desktop";
    this.verticalNavType = "expanded";
    this.verticalEffect = "shrink";
    this.vnavigationView = "view1";
    this.freamType = "theme1";
    this.sidebarImg = "false";
    this.sidebarImgType = "img1";
    this.layoutType = "light";

    this.headerTheme = "themelight5";
    this.pcodedHeaderPosition = "fixed";

    this.liveNotification = "an-off";
    this.profileNotification = "an-off";

    this.liveInvite = "an-off";
    this.profileInvite = "an-off";

    this.navRight = "nav-on";

    this.windowWidth = window.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    this.toggleOn = true;
    this.navBarTheme = "themelight1";
    this.activeItemTheme = "theme10";
    this.pcodedSidebarPosition = "fixed";
    this.menuTitleTheme = "theme6";
    this.dropDownIcon = "style1";
    this.subItemIcon = "style1";

    this.displayBoxLayout = "d-none";
    this.isVerticalLayoutChecked = false;
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;
    this.headerFixedMargin = "56px";
    this.sidebarFixedHeight = "calc(100vh - 56px)";
    this.itemBorderStyle = "none";
    this.subItemBorder = true;
    this.itemBorder = true;

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);

    this.getUser();
  }

  ngOnInit() {
    this.inviteConfig = { type: "received", status: "requested" };
    this.notificationConfig = { read: false };
  }

  public getUser() {
    this.loading = true;

    this.currentUserSubscription = this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.menuItems = this.menuService.getMenuItemsForAuth(userData);
        this.loading = false;
      }
    );
  }

  ngOnDestroy() {
    this.currentUserSubscription.unsubscribe();
  }

  public logout() {
    this.userService.logOut().subscribe(() => {
      this.menuItems = this.menuService.getDefaultMenuItems();
      this.userService.purgeAuth();
      window.location.reload();
    });
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (
      this.pcodedDeviceType === "tablet" &&
      this.windowWidth >= 768 &&
      this.windowWidth <= 1024
    ) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === "phone" && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = "nav-off";
    } else {
      this.navRight = "nav-on";
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = "tablet";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = "phone";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else {
      this.pcodedDeviceType = "desktop";
      this.verticalNavType = "expanded";
      this.verticalEffect = "shrink";
    }
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === "nav-on" ? "nav-off" : "nav-on";
  }

  // -------------------------------------------------------------------------------

  toggleLiveNotification() {
    this.liveNotification =
      this.liveNotification === "an-off" ? "an-animate" : "an-off";
    this.liveNotificationClass =
      this.liveNotification === "an-animate" ? "active" : "";
  }

  toggleProfileNotification() {
    this.profileNotification =
      this.profileNotification === "an-off" ? "an-animate" : "an-off";
    this.profileNotificationClass =
      this.profileNotification === "an-animate" ? "active" : "";
  }

  notificationOutsideClick(ele: string) {
    if (ele === "live" && this.liveNotification === "an-animate") {
      this.toggleLiveNotification();
    } else if (ele === "profile" && this.profileNotification === "an-animate") {
      this.toggleProfileNotification();
    }
  }

  // -------------------------------------------------------------------------------

  toggleLiveInvite() {
    this.liveInvite = this.liveInvite === "an-off" ? "an-animate" : "an-off";
    this.liveInviteClass = this.liveInvite === "an-animate" ? "active" : "";
  }

  toggleProfileInvite() {
    this.profileInvite =
      this.profileInvite === "an-off" ? "an-animate" : "an-off";
    this.profileInviteClass =
      this.profileInvite === "an-animate" ? "active" : "";
  }

  inviteOutsideClick(ele: string) {
    if (ele === "live" && this.liveInvite === "an-animate") {
      this.toggleLiveInvite();
    } else if (ele === "profile" && this.profileInvite === "an-animate") {
      this.toggleProfileInvite();
    }
  }

  // -------------------------------------------------------------------------------

  toggleOpened() {
    if (this.windowWidth < 992) {
      this.toggleOn =
        this.verticalNavType === "offcanvas" ? true : this.toggleOn;
      if (this.navRight === "nav-on") {
        this.toggleHeaderNavRight();
      }
    }
    this.verticalNavType =
      this.verticalNavType === "expanded" ? "offcanvas" : "expanded";
    document.querySelector("#main_navbar").classList.toggle("show-menu");
  }

  onClickedOutsideSidebar(e: Event) {
    if (
      (this.windowWidth < 992 &&
        this.toggleOn &&
        this.verticalNavType !== "offcanvas") ||
      this.verticalEffect === "overlay"
    ) {
      this.toggleOn = true;
      this.verticalNavType = "offcanvas";
      document.querySelector("#main_navbar").classList.remove("show-menu");
    }
  }

  toggleRightbar() {
    this.configOpenRightBar = this.configOpenRightBar === "open" ? "" : "open";
  }

  setNavBarTheme(theme: string) {
    if (theme === "themelight1") {
      this.navBarTheme = "themelight1";
      this.menuTitleTheme = "theme1";
      this.sidebarImg = "false";
    } else {
      this.menuTitleTheme = "theme6";
      this.navBarTheme = "theme1";
      this.sidebarImg = "false";
    }
  }

  setLayoutType(type: string) {
    this.layoutType = type;
    if (type === "dark") {
      this.headerTheme = "theme1";
      this.sidebarImg = "false";
      this.navBarTheme = "theme1";
      this.menuTitleTheme = "theme6";
      document.querySelector("body").classList.add("dark");
    } else if (type === "light") {
      this.sidebarImg = "false";
      this.headerTheme = "theme5";
      this.navBarTheme = "themelight1";
      this.menuTitleTheme = "theme1";
      document.querySelector("body").classList.remove("dark");
    } else if (type === "img") {
      this.sidebarImg = "true";
      this.headerTheme = "theme1";
      this.navBarTheme = "theme1";
      this.menuTitleTheme = "theme6";
      document.querySelector("body").classList.remove("dark");
    }
  }

  setVerticalLayout() {
    this.isVerticalLayoutChecked = !this.isVerticalLayoutChecked;
    if (this.isVerticalLayoutChecked) {
      this.verticalLayout = "box";
      this.displayBoxLayout = "";
    } else {
      this.verticalLayout = "wide";
      this.displayBoxLayout = "d-none";
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector("body").setAttribute("themebg-pattern", pattern);
  }

  setSidebarPosition() {
    this.isSidebarChecked = !this.isSidebarChecked;
    this.pcodedSidebarPosition =
      this.isSidebarChecked === true ? "fixed" : "absolute";
    this.sidebarFixedHeight =
      this.isHeaderChecked === true
        ? "calc(100vh + 56px)"
        : "calc(100vh - 56px)";
  }

  setHeaderPosition() {
    this.isHeaderChecked = !this.isHeaderChecked;
    this.pcodedHeaderPosition =
      this.isHeaderChecked === true ? "fixed" : "relative";
    this.headerFixedMargin = this.isHeaderChecked === true ? "56px" : "";
  }
}
